export const isSameSet = <T>(listA: Iterable<T>, listB: Iterable<T>) => {
  const setA = new Set(listA);
  const setB = new Set(listB);
  return (
    setA.size === setB.size && setA.size === new Set([...setA, ...setB]).size
  );
};
